import { ChangeEvent, FC } from 'react';
import {
  Button,
  Checkbox,
  PopoverBody,
  PopoverFooter,
  Stack,
} from '@chakra-ui/react';

import { DataRoomObjectFragment } from '../../graphql/generated';
import { FilterMenu } from '../filter-menu/filter-menu';

type TreatyFilterProps = {
  onSelectAll: () => void;
  onDeselectAll: () => void;
  selectedTreaties: string[];
  onChange: (value: string) => void;
  treaties: DataRoomObjectFragment[];
};

export const TreatyFilter: FC<TreatyFilterProps> = ({
  treaties,
  onChange,
  onSelectAll,
  onDeselectAll,
  selectedTreaties,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value);
  };

  return (
    <FilterMenu label="Treaties" numOfSelectedItems={selectedTreaties.length}>
      <PopoverBody minW="60">
        <Stack>
          {treaties.map((treaty) => (
            <Checkbox
              size="md"
              key={treaty.cedant}
              value={treaty.cedant}
              onChange={handleChange}
              data-testid={treaty.cedant}
              isChecked={selectedTreaties.includes(treaty.cedant)}
            >
              {treaty.name}
            </Checkbox>
          ))}
        </Stack>
      </PopoverBody>
      <PopoverFooter display="flex" justifyContent="space-between">
        <Button
          size="sm"
          variant="link"
          colorScheme="blue"
          justifyContent="start"
          onClick={onSelectAll}
        >
          Select All
        </Button>
        <Button
          size="sm"
          variant="link"
          colorScheme="blue"
          justifyContent="start"
          onClick={onDeselectAll}
          disabled={!selectedTreaties.length}
        >
          Deselect All
        </Button>
      </PopoverFooter>
    </FilterMenu>
  );
};
